import { useRouterState } from "@tanstack/react-router";
import { useTolgee } from "@tolgee/react";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { readLocale } from "../../lib/locale";
import { initializeLocaleAtom } from "../../stores/locale-store";

export function LocaleSync() {
	const tolgee = useTolgee();
	const initializeLocale = useSetAtom(initializeLocaleAtom);
	const pathname = useRouterState({ select: (s) => s.location.pathname });

	// Re-resolve on every navigation: readLocale() is URL-prefix-aware (/ko/... →
	// ko), so moving between locale-prefixed routes re-syncs the atom + Tolgee.
	// 판정은 반드시 라우터 상태 pathname으로 — SPA navigate 중 window.location이
	// 늦게 커밋되는 구간에서 이전 URL의 locale로 되돌리는 레이스가 있었다
	// (ko→en 전환이 두 번 클릭돼야 먹히던 버그의 원인).
	useEffect(() => {
		const locale = readLocale(pathname);
		initializeLocale(locale);
		tolgee.changeLanguage(locale);
	}, [pathname, initializeLocale, tolgee]);

	return null;
}
